// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__1kG5a","bannerSection":"Banner_bannerSection__F2GOR","carousel":"Banner_carousel__2SHtv"};